import { Component } from "@angular/core";
import { Platform, NavParams, ViewController } from "ionic-angular";
import { SummaryServiceProvider } from "../../../../providers/wh/summary-service";

@Component({
  selector: "change-pass-modal",
  templateUrl: "change-pass-modal.html",
  providers: [SummaryServiceProvider]
})
export class ChangePasswordModalComponent {
  data;
  password: any;
  updateError: any = false;

  constructor(
    private plt: Platform,
    public params: NavParams,
    public summaryService: SummaryServiceProvider,
    public viewCtrl: ViewController
  ) {
    this.data = this.params.get("data");
  }

  changePassword() {
    this.updateError = false;

    var merchantObj: any = {};
    if (this.password) {
      merchantObj.password = this.password;
      var payload: any = {
        merchants: JSON.stringify(merchantObj)
      };
      this.data.password = this.password;
      this.viewCtrl.dismiss(this.data);

      if (this.data.id) {
        this.summaryService
          .patchCPInfo(this.data.id, payload)
          .then(res => {
            this.updateError = false;
            this.data.password = this.password;
            this.viewCtrl.dismiss(this.data);
          })
          .catch(err => {
            this.updateError = true;
          });
      }
    }
  }

  checkPasswordValidity() {
    this.updateError = false;
    if (this.password && this.password.length >= 6) {
      return true;
    } else {
      return false;
    }
  }

  dismiss() {
    this.viewCtrl.dismiss(true);
  }
}



// WEBPACK FOOTER //
// ./src/pages/backoffice/add-sites/change-pass-modal/change-pass-modal.ts